import ReactGa from 'react-ga'
// if(!window.isServerSide) {
//   ReactGa.initialize(GOOGLE_ANALYTICS_ID)
// }
ReactGa.initialize(GOOGLE_ANALYTICS_ID)
class Mock {
  trackEvent(category, action) {
    console.log(`Tracking Event: ${category}/${action}`)
  }
}

class GoogleAnalytics {
  trackEvent(category, action) {
    // console.log('Track: category='+category+' action='+action)
    ReactGa.event({ category, action })
  }
}

class FacebookMock {
  track(event, data) {
    console.log(`Tracking FB Event: ${event}`, data)
  }
}

class Facebook {
  track(event, data) {
    if (window.fbq) {
      window.fbq('track', event, data)
    } else {
      console.log('Failed to log fb event:', event)
    }
  }
}

let tracker = new Mock()
let fbTracker = new FacebookMock()
if (PRODUCTION) {
  tracker = new GoogleAnalytics()
  fbTracker = new Facebook()
}
else if(GOOGLE_ANALYTICS_ID) {
  tracker = new GoogleAnalytics()
}

export default {
  trackSearchStart: searchQuery => {
    fbTracker.track('Search', { search_string: searchQuery })
  },

  trackPayment(success, bookingType, price, currency) {
    let successString = 'PaymentFailed'
    if (success) {
      /* Payment  */
      successString = 'PaymentCompleted'
      fbTracker.track('Purchase', { value: price, currency })
    }

    let category = 'Enquiry'
    if (bookingType === 'direct') {
      category = 'BookNow'
    }

    tracker.trackEvent(category, successString)
  },

  trackEnquiryHostResponse: approved => {
    let action = 'HostDeclined'
    if (approved) {
      action = 'HostApproved'
      fbTracker.track('InitiateCheckout')
    }

    tracker.trackEvent('Enquiry', 'HostResponded')
    tracker.trackEvent('Enquiry', action)
  },

  trackZendeskChat: () => {
    tracker.trackEvent('Zendesk', 'Chat')
  },
  trackContentRegistrationEntryA: () => {
    // Goal 9
    console.log('Goal 9');
    tracker.trackEvent('Content Registration', 'Entry (50% of content)')
  },
  trackContentRegistrationEntryB: () => {
    // Goal 3
    console.log('Goal 3');
    tracker.trackEvent('Content Registration', 'Entry (80% of content)')
  },
  contentRegistrationExitA: () => {
    // Goal 14
    console.log('Goal 14');
    tracker.trackEvent('Content Registration', 'Exit (50% of content)')
  }, 
  contentRegistrationExitB: () => {
    // Goal 12
    console.log('Goal 12');
    tracker.trackEvent('Content Registration', 'Exit (80% of content)')
  }, 
  trackZendeskChat: () => {
    tracker.trackEvent('Zendesk', 'Chat')
  },

  trackDestinationSearch: query => {
    // Goal 6
    console.log('Goal 6');
    tracker.trackEvent('Search', 'DestinationSearch')
    fbTracker.track('ViewContent', { content_name: `Search: ${query}` })
  },

  trackPropertyPageView: title => { 
    // Goal 7
    console.log('Goal 7');
    tracker.trackEvent('PropertyPage', 'Enter')
    fbTracker.track('Search', { contents: `Property: ${title}` })
  },

  trackEnquiryButton: () => {
    console.log('track enquiry button')
    tracker.trackEvent('Enquiry', 'Enquiry button clicked')
    fbTracker.track('AddToCart')
  },
  trackMobileBookButton: () => {
    /* Goal 10 */
    console.log('goal 10')
    tracker.trackEvent('Enquiry/Book', 'Book button on mobile SRP, to open enquiry/booking dialogue')
  },  

  trackEnquiryNextBooking: () => {
    console.log('goal 11')
    tracker.trackEvent('Payment', 'Click "next to payment button"')
    fbTracker.track('AddToCart')
  },
  trackPaymentFail: () => {
    /* Goal 12 */
    console.log('goal 12')
    tracker.trackEvent('Book Now', 'Clicked Pay Button but NOT gone through due to timeout')
  },
  trackNoSearchResults: () => {
    /* Goal 14 */
    tracker.trackEvent('Search', 'NoResults')
  },

  trackEnquiryBookNow: () => {
    /* Goal 15 is here! */
    console.log('goal 15')
    tracker.trackEvent('Enquiry', 'Enter Booking Dialog')
    fbTracker.track('InitiateCheckout')
    fbTracker.track('AddToCart')
  },

  trackEnquiryCreated: () => {
    /* goal 16,   */
    console.log('goal 16')
    tracker.trackEvent('Enquiry', 'Created')
    fbTracker.track('CompleteRegistration')
  },

  trackPaymentDone: bookingType => {
    /* Goal 17 */
    console.log('goal 17')
    let category = 'Enquiry'
    if (bookingType === 'direct') {
      category = 'BookNow'
    } else {
      fbTracker.track('InitiateCheckout')
      fbTracker.track('AddPaymentInfo')
    }
    tracker.trackEvent(category, 'Payment Done')
  },

  trackEnquiryContactHost: () => {
    /* Happens when MRP enquiry sent */
    /* Goal 18 */
    console.log('goal 18');
    tracker.trackEvent('Enquiry', 'Contact Host Button Clicked')
    fbTracker.track('AddToCart')
  },

  trackEnquiryButtonClicked: () => {
    /* Goal 19, When enquiry is made in MRP, also in SRP */
    console.log('goal 19')
    tracker.trackEvent('Enquiry', 'Send Enquiry button clicked')
    fbTracker.track('AddToCart')
  },

  trackEnquirySendMessage: () => {
    /* Goal 20, after clicking final "send message" button */
    console.log('goal 20');
    tracker.trackEvent('Enquiry', 'Send message button clicked')
    fbTracker.track('CompleteRegistration')
  },
  
  trackEnterBookingDialog: () => {
    /* Goal 21, when mobile user click "book now" button to bring up dialog */
    console.log('goal 21');
    tracker.trackEvent('Enquiry', 'Enter Booking Dialog')
    fbTracker.track('AddToCart')
  }  
}